export default interface IRecentItem {
    id: number;
    type: RecentItemType;
}

export enum RecentItemType {
    Lead = "Lead",
    LeaseComp = "LeaseComp",
    SaleComp = "SaleComp",
    Deal = "Deal",
    TenantInMarket = "TenantInMarket",
    Company = "Company",
}